<div class="topHead">
    <h2>Reports</h2>
    <div class="logout">
        <app-log-out class="logout"></app-log-out>
    </div>
</div>
<div class="centerWrap">
    <div class="pageTitleBox">
        <h2>Reports</h2> 
    </div>
    <div class="adminTabWrap">
            <div class="dateRangeWrap">
                <!-- <div class="dateTitle">Date Range</div> -->
                <div class="dateWrap">
                    <span>Start Date:</span>
                    <mat-form-field>
                        <input matInput [matDatepicker]="picker1" placeholder="Start Date" [formControl]="startDate">
                        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                        <mat-datepicker #picker1></mat-datepicker>
                      </mat-form-field>
                    </div>
                    <div class="dateWrap">
                      <span>End Date:</span>
                      <mat-form-field>
                        <input matInput [matDatepicker]="picker2" placeholder="End Date"
                         [min]="startDate.value" [formControl]="endDate">
                        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                        <mat-datepicker #picker2></mat-datepicker>
                      </mat-form-field>
                </div>
        </div>
        <div class="tableWrap">
            <table class="mat-elevation-z8 w-100" matSort (matSortChange)="sortData($event)">
                <thead>
                    <tr>
                        <th>
                            <div mat-sort-header="name"><b></b>Report Name</div>
                        </th>
                        <th>Description</th>
                        <th>&nbsp;&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="selectTr" *ngFor="let values of sortedData">
                        <td>
                            <div>
                               <a class="btn-link"> <span> {{values.name}}</span></a>
                                <b></b>
                            </div>
                        </td>
                        <td class="userTdWrap">{{values.description}}</td>
                        <td><a href="javascript:void" (click)="downloadsExcel(values.fileName,values.report,startDate.value,endDate.value)">Download</a>
                            <!-- <a href="assets/downloads/KKmsdashboard.xlsx" >Download</a>-->
                        </td>
                    </tr>

                </tbody>
            </table>
        </div>
    </div>
</div>
<ngx-spinner><p style="color: white" > Loading... </p></ngx-spinner>
